import React from 'react';
import { useIntl } from 'react-intl';

import { Tooltip } from 'ui-components/components/tooltip';
import { TooltipContent } from 'ui-components/components/tooltip/tooltip-content';
import { Text, TextType } from 'ui-components/components/text';

import SmartFillIcon from '../../../../configure-shipment/icons/smartfill_icon.svg';

import { messages } from './messages';
import style from './style.module.css';

export const SmartFillTooltip = ({ children, count, shouldHideTooltip = false }) => {
  const intl = useIntl();
  const tooltipContent = <Text formattedMessageValues={{ count }} textType={TextType.Caption} value={messages.tooltipMessage} />;

  return (
    <>
      <Tooltip position='top-left' shouldHideTooltip={shouldHideTooltip}>
        <div className={style['smart-fill-tooltip']}>
          {children}
          {!shouldHideTooltip && (
            <img alt={intl.formatMessage(messages.smartfillAltText)} className={style['smart-fill-icon']} src={SmartFillIcon} />
          )}
        </div>
        <TooltipContent>{tooltipContent}</TooltipContent>
      </Tooltip>
    </>
  );
};
